import Map from "./Map"
import NPC from "./NPC"
import Mob from "./Mob"
import Quest from "./Quest"
import Const from "../Const"
import Item from "./Item"
import BaseAPI from "./API"

class API {
	constructor(basePath) {
		this.Map = new Map(this)
		this.NPC = new NPC(this)
		this.Mob = new Mob(this)
		this.Quest = new Quest(this)
		this.Item = new Item(this)
		this.Job = new BaseAPI(this, 'job')
		this.Diff = () => this.invoke('diff')
		this.DiffGrouped = () => this.invoke('diff/grouped')
		this.WZ = (path) => this.fetch(`${Const.apiEndPoint}/wz/${path}`)
  }

  SetRegionVersion(region, version)
  {
		console.log(`db: ${region}/${version}`)
    this.region = region
    this.version = version
    this.DB = new Dexie(`wiki-${region}-${version}`)
		this.DB.version(1).stores({
			map: 'id,__index,name,streetName',
			npc: 'id,__index,name',
			mob: 'id,__index,name',
			quest: 'id,__index,name',
			item: 'id,__index,name,desc',
			job: 'id,__index,name',
			wz: 'region,mapleVersionId'
		})
  }

	invoke(url, queryParameters) {
		return this.fetch([Const.apiRoot(), url].join('/'), queryParameters)
	}

	RetryLater(url, queryParameters, retryCount)
	{
		let currentPath = window.location.pathname
		return new Promise((res, rej) => {
			setTimeout(function () {
				if (window.location.pathname != currentPath)
					rej()

        console.warn(`Retrying ${url} ${JSON.stringify(queryParameters)}`)

        if (retryCount > 3) rej('Couldn\'t load resource')

				res()
			}, 500)
		}).then(() => this.fetch(url, queryParameters, (retryCount || 0) + 1))
	}

	fetch(url, queryParameters, retryCount) {
		let queryString = ''

		if (queryParameters)
			queryString = Object.keys(queryParameters).reduceRight((total, current) => {
				total += ('&' + encodeURIComponent(current) + "=" + encodeURIComponent(queryParameters[current]))
				return total
			}, "?")

		let fetchUrl = url + queryString

		return fetch(fetchUrl).catch(err => {
      console.warn('API error, scheduling to retry')
			return this.RetryLater(url, queryParameters, retryCount)
		}).then(res => {
			if (res.status == 502 || res.status == 503 || res.status == 504)
				return this.RetryLater(url, queryParameters, retryCount)

			if (res.status == 404 || res.status == 500)
			{
				// TODO: Toast
				console.error(`${fetchUrl} gave status code ${res.status}`)
				throw new Error(`Invalid response from API for ${fetchUrl}`)
			}

			try {
				return res.json()
			} catch (err) {
				return this.RetryLater(url, queryParameters)
			}
		})
	}
}

export default new API()
